import type {
  Haftungsausschluss,
  HaftungsausschlussTyp,
  Rechtstext,
  RechtstextTyp,
} from '@/shared/Buergschaften/types';
import { SharedBuergschaftService } from '@/shared/api/services/rechtstext';

export class RechtstextService extends SharedBuergschaftService {
  async holeHaftungsausschluss(typ: HaftungsausschlussTyp): Promise<Haftungsausschluss> {
    return this.httpClient.get(`${this.rechtstextServiceBaseUrl}/rechtstext`, {
      params: { rechtstextTyp: typ },
    });
  }

  async holeRechtstext(typ: RechtstextTyp): Promise<Rechtstext> {
    return this.httpClient.get(`${this.rechtstextServiceBaseUrl}/rechtstext`, {
      params: { rechtstextTyp: typ },
    });
  }
}
